"use client";

import styled from "styled-components";

interface TitleCardProps {
  $align: string;
}

export const TitleCard = styled.h2<TitleCardProps>`
  font-family: "Roboto Medium";
  font-size: 15px;
  color: var(--colorTitle);
  margin-bottom: 1rem;
  width: 100%;
  text-align: ${({ $align }) => $align || "left"};

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;
